import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api";
import LazyLoad from "react-lazyload";
import { Link, useNavigate } from "react-router-dom";
import SliderModule from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import RightNavigationArrow from "../utlis/RightNavigationArrow";
const arrowImage =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAItJREFUeAGNz70NgzAQBeD3nBTXRPIILlkjGyQdZTwZbbqMkDUoGYHSEj+HQQJZ/Aiuejp99t3xkeUfgAVOyuBi0bqXDSI2bd4BR5ofVJc+1y9tlrsO/MfoQNYzNocIqFT7dzJlHzXQp8TQpcfsoVB+q3SauYImGL8uztC04w3wbcQt1G9QkBoS/BgHNqo+V7vQUDAAAAAASUVORK5CYII=";

const Slider = SliderModule.default || SliderModule;
const Events = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,

    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const eventData = await getEvents();
        const validEvents = eventData.filter(
          (item) =>
            typeof item.title === "string" && item.title.trim().length > 0,
        );
        const sortedEvents = [...validEvents].sort(
          (a, b) => new Date(b.date) - new Date(a.date),
        );
        const only4enty = sortedEvents.slice(0, 4);
        setData(only4enty);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const navigate = useNavigate();

  function handleLinkClick() {
    navigate("/events");
  }
  return (
    <>
      <div className="eventsec">
        <div className="border-blk">
          <h3>
            Upcoming Events <Link to="/"></Link>
          </h3>
          <div
            className="row event_container recentactivites event_home"
            onClick={() => {
              handleLinkClick();
            }}
          >
            <Slider {...settings}>
              {[...data]
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map(function (item, index, arr) {
                  return (
                    <div className="col-lg-6">
                      <div className="single_event_container">
                        {item.images.length > 0 ? (
                          <img
                            src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images[0]}`}
                            alt=""
                          />
                        ) : (
                          <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/eventsss.png" />
                        )}
                        <h5>{item.title}</h5>
                        <p className="date" date>
                          {new Date(item.date).getDay() +
                            " " +
                            new Date(item.date).toLocaleString("en-US", {
                              month: "short",
                            })}
                        </p>
                        <div className="loc_time">
                          <p>{item.venue || "School Campus"}</p>
                          <p>{item.time.slice(0, 5) || "08:00"} AM</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default Events;
